import { Box } from "@mui/material";
import { Delete2Icon, ExclamationIcon, RestaurantIcon } from "../../assets/icons";

export function DeleteLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        background: "#FEF6F6",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "56px",
        margin: "auto",
      }}
    >
      <Delete2Icon width={24} height={24} color="#e24040" />
    </Box>
  );
}

export function PortionLabelIcon(props?: { width?: number; height?: number; outerWidth?: number }) {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        background: "rgba(19, 111, 215, 0.08)",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: `${props?.outerWidth ? props.outerWidth + "px" : "56px"}`,
        margin: "auto",
      }}
    >
      <RestaurantIcon width={props?.width ?? 24} height={props?.height ?? 24} color="#136FD7" />
    </Box>
  );
}

export function SendLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        background: "rgba(19, 111, 215, 0.08)",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "56px",
        margin: "auto",
      }}
    >
      <ExclamationIcon width={24} height={24} color="#136FD7" />
    </Box>
  );
}
